import styled from 'styled-components';

export const StyledVisibleMotContent = styled.div`
  min-width: 0;
  min-height: 0;
`;
